import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import hasInterface from '../../../../../hasInterface';
import Position from '../../geomgraph/Position';
import Coordinate from '../../geom/Coordinate';
import Orientation from '../../algorithm/Orientation';
import Collections from '../../../../../java/util/Collections';
import DirectedEdge from '../../geomgraph/DirectedEdge';
import LineSegment from '../../geom/LineSegment';
import Comparable from '../../../../../java/lang/Comparable';
import ArrayList from '../../../../../java/util/ArrayList';
import List from '../../../../../java/util/List';
var SubgraphDepthLocater = /*#__PURE__*/function () {
  function SubgraphDepthLocater() {
    _classCallCheck(this, SubgraphDepthLocater);
    SubgraphDepthLocater.constructor_.apply(this, arguments);
  }
  _createClass(SubgraphDepthLocater, [{
    key: "findStabbedSegments",
    value: function findStabbedSegments() {
      if (arguments.length === 1) {
        var stabbingRayLeftPt = arguments[0];
        var stabbedSegments = new ArrayList();
        for (var i = this._subgraphs.iterator(); i.hasNext();) {
          var bsg = i.next();
          var env = bsg.getEnvelope();
          if (stabbingRayLeftPt.y < env.getMinY() || stabbingRayLeftPt.y > env.getMaxY()) continue;
          this.findStabbedSegments(stabbingRayLeftPt, bsg.getDirectedEdges(), stabbedSegments);
        }
        return stabbedSegments;
      } else if (arguments.length === 3) {
        if (hasInterface(arguments[2], List) && arguments[0] instanceof Coordinate && arguments[1] instanceof DirectedEdge) {
          var _stabbingRayLeftPt = arguments[0],
            dirEdge = arguments[1],
            _stabbedSegments = arguments[2];
          var pts = dirEdge.getEdge().getCoordinates();
          for (var _i = 0; _i < pts.length - 1; _i++) {
            this._seg.p0 = pts[_i];
            this._seg.p1 = pts[_i + 1];
            if (this._seg.p0.y > this._seg.p1.y) this._seg.reverse();
            var maxx = Math.max(this._seg.p0.x, this._seg.p1.x);
            if (maxx < _stabbingRayLeftPt.x) continue;
            if (this._seg.isHorizontal()) continue;
            if (_stabbingRayLeftPt.y < this._seg.p0.y || _stabbingRayLeftPt.y > this._seg.p1.y) continue;
            if (Orientation.index(this._seg.p0, this._seg.p1, _stabbingRayLeftPt) === Orientation.RIGHT) continue;
            var depth = dirEdge.getDepth(Position.LEFT);
            if (!this._seg.p0.equals(pts[_i])) depth = dirEdge.getDepth(Position.RIGHT);
            var ds = new DepthSegment(this._seg, depth);
            _stabbedSegments.add(ds);
          }
        } else if (hasInterface(arguments[2], List) && arguments[0] instanceof Coordinate && hasInterface(arguments[1], List)) {
          var _stabbingRayLeftPt2 = arguments[0],
            dirEdges = arguments[1],
            _stabbedSegments2 = arguments[2];
          for (var _i2 = dirEdges.iterator(); _i2.hasNext();) {
            var de = _i2.next();
            if (!de.isForward()) continue;
            this.findStabbedSegments(_stabbingRayLeftPt2, de, _stabbedSegments2);
          }
        }
      }
    }
  }, {
    key: "getDepth",
    value: function getDepth(p) {
      var stabbedSegments = this.findStabbedSegments(p);
      if (stabbedSegments.size() === 0) return 0;
      var ds = Collections.min(stabbedSegments);
      return ds._leftDepth;
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._subgraphs = null;
      this._seg = new LineSegment();
      var subgraphs = arguments[0];
      this._subgraphs = subgraphs;
    }
  }]);
  return SubgraphDepthLocater;
}();
export { SubgraphDepthLocater as default };
var DepthSegment = /*#__PURE__*/function () {
  function DepthSegment() {
    _classCallCheck(this, DepthSegment);
    DepthSegment.constructor_.apply(this, arguments);
  }
  _createClass(DepthSegment, [{
    key: "compareTo",
    value: function compareTo(obj) {
      var other = obj;
      if (this._upwardSeg.minX() >= other._upwardSeg.maxX()) return 1;
      if (this._upwardSeg.maxX() <= other._upwardSeg.minX()) return -1;
      var orientIndex = this._upwardSeg.orientationIndex(other._upwardSeg);
      if (orientIndex !== 0) return orientIndex;
      orientIndex = -1 * other._upwardSeg.orientationIndex(this._upwardSeg);
      if (orientIndex !== 0) return orientIndex;
      return this._upwardSeg.compareTo(other._upwardSeg);
    }
  }, {
    key: "compareX",
    value: function compareX(seg0, seg1) {
      var compare0 = seg0.p0.compareTo(seg1.p0);
      if (compare0 !== 0) return compare0;
      return seg0.p1.compareTo(seg1.p1);
    }
  }, {
    key: "toString",
    value: function toString() {
      return this._upwardSeg.toString();
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [Comparable];
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._upwardSeg = null;
      this._leftDepth = null;
      var seg = arguments[0],
        depth = arguments[1];
      this._upwardSeg = new LineSegment(seg);
      this._leftDepth = depth;
    }
  }]);
  return DepthSegment;
}();
SubgraphDepthLocater.DepthSegment = DepthSegment;